// extracted by mini-css-extract-plugin
export default {"shareButton":"Share_shareButton__aGCja"};